module.exports = __webpack_public_path__ + "static/media/ic-chatbot.f11ff75d.png";